import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { useLocation } from "react-router-dom"
import { promotionsData } from "../data/PromotionData"
import ModuleJiliGrandSlot from "./promotion_modules/ModuleJiliGrandSlot"

export default function JiliGrandSlot({ isLightMode }) {
  const navigate = useNavigate()
  const [activeModal, setActiveModal] = useState("")
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const modalComponents = {
    "BNG Splash Spin Into Summer": ModuleJiliGrandSlot,
  }

  const data = promotionsData.find((promo) => promo.title === "Jili Grand Slot")

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  const handleJiliGrandSlot = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("BNG Splash Spin Into Summer")
    }
  }

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  const location = useLocation()
  const isAppPromo = location.pathname.startsWith("/app-promotion")

  // If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  useEffect(() => {
    const isAppPromotion = location.pathname.startsWith("/app-promotion")

    if (isAppPromotion) {
      const theme = isLightMode ? "light" : "dark"
      document.documentElement.dataset.theme = theme
      localStorage.setItem("theme", theme)
    }
  }, [location.pathname])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Jili Grand Slot</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a
                href={
                  isAppPromo
                    ? "/promotion/".replace("/promotion", "/app-promotion")
                    : "/promotion/"
                }
              >
                Promotions
              </a>{" "}
              / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Jili Grand Slot</h1>
                <h2>4 Weeks of Slot Battles & Big Wins!</h2>
                <h2>WIN ₱80,000+ IN PRIZES!</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period: </strong>
                  <span>May 04, 2026 - June 01, 2026</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                  Get ready for 4 weeks of non-stop JILI action!
                </p>
                <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                  Play your favorite slots, climb the leaderboard, and win Free
                  Spins & Free Credits every week!
                </p>
                <br />
                {isLoggedIn && !isAppPromo && (
                  <div className="promotion-tnc-btn-wrapper">
                    <button
                      className="promotion-cta-btn"
                      onClick={handleJiliGrandSlot}
                    >
                      Leaderboard
                    </button>
                  </div>
                )}
                <strong>How to Qualify</strong>

                <strong>Week 1&2: Spin Masters Challenge</strong>
                <p>Period: May 4 – May 18 (12PM)</p>
                <br />
                <p>The more you spin, the more chances you win!</p>
                <br />
                <strong>How to Win:</strong>
                <ul>
                  <li>Earn points by spinning (1 spin = 1 point)</li>
                  <li>Rank higher by playing more</li>
                </ul>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <tr>
                        <th colSpan={2}>
                          Top 30 players every Monday will win!
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={2}>Prizes (Free Spins | ₱5 per spin)</th>
                      </tr>
                      <tr>
                        <th>Rank</th>
                        <th>Free Spins (₱5 per spin)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1st</td>
                        <td>200 Free Spins</td>
                      </tr>
                      <tr>
                        <td>2nd</td>
                        <td>120 Free Spins</td>
                      </tr>
                      <tr>
                        <td>3rd</td>
                        <td>100 Free Spins</td>
                      </tr>
                      <tr>
                        <td>4th–10th</td>
                        <td>80 Free Spins</td>
                      </tr>
                      <tr>
                        <td>11th–20th</td>
                        <td>60 Free Spins</td>
                      </tr>
                      <tr>
                        <td>21st–30th</td>
                        <td>50 Free Spins</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <strong>Week 3&4: Grand Turnover Race</strong>
                <p>Period: May 18 – June 01 (12PM)</p>
                <br />
                <p>
                  The ultimate showdown begins! Spin more, climb higher, and win
                  big!
                </p>
                <br />
                <strong>How to Win:</strong>
                <p>The more you play, the higher your turnover</p>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <tr>
                        <th colSpan={2}>
                          Top 30 players every Monday will win!
                        </th>
                      </tr>
                      <tr>
                        <th colSpan={2}>No wagering required on prizes!</th>
                      </tr>
                      <tr>
                        <th>Rank</th>
                        <th>Free Credits</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1st</td>
                        <td>₱5,000</td>
                      </tr>
                      <tr>
                        <td>2nd</td>
                        <td>₱4,000</td>
                      </tr>
                      <tr>
                        <td>3rd</td>
                        <td>₱3,000</td>
                      </tr>
                      <tr>
                        <td>4th</td>
                        <td>₱2,000</td>
                      </tr>
                      <tr>
                        <td>5th</td>
                        <td>₱1,500</td>
                      </tr>
                      <tr>
                        <td>6th–10th</td>
                        <td>₱1,200</td>
                      </tr>
                      <tr>
                        <td>11th–20th</td>
                        <td>₱800</td>
                      </tr>
                      <tr>
                        <td>21st–30th</td>
                        <td>₱500</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <strong>Terms and Conditions:</strong>
                <ol>
                  <li>
                    Simply play ANY JILI Slot Game during the promo period to
                    join.
                  </li>
                  <li>
                    Promo runs from May 4 – June 01, 2026 (12PM) and is divided
                    into weekly challenges.
                  </li>
                  <li>
                    Leaderboard Winners will be announced every Monday at 12PM
                  </li>
                  <li>
                    All prizes will be credited every Monday 3PM with NO
                    wagering requirement.
                  </li>
                  <li>Only one account per player is allowed.</li>
                  <li>
                    In case of a tie, the player who reached the result earlier
                    will rank higher.
                  </li>
                  <li>
                    FGH reserves the right to amend, extend, or terminate this
                    promotion at any time without prior notice.
                  </li>
                </ol>
                {!isAppPromo && (
                  <div className="promotion-tnc-cta">
                    <a
                      className="promotion-cta-btn"
                      href="/slots/?provider=JILI"
                    >
                      PLAY NOW
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}
    </>
  )
}
